import { ICategory } from '../../categorypage/categorypage.d';
import {
    IBrick,
    IFlexibleSet,
} from '../../flexSets/flexSetTile/flex-set-tile.d';
import { ISearchBrickItem, ISearchFlexibleSet } from '../searchresultpage.d';

export function mapToFlexibleSetTiles(
    flexSets: ISearchFlexibleSet[]
): IFlexibleSet[] {
    return flexSets.map((set, i) => {
        return {
            fsCode: set.fsCode,
            flexibleSetImageFullPath: set.flexibleSetImage,
            salesDesignation: set.salesDesignation,
            isAvailable: true, // placeholder value
            navigationKey: null,
            fspLink: set.url,
            sortedBricks: mapToFlexibleSetBricks(flexSets[i].sortedBricks),
        };
    });
}

function mapToFlexibleSetBricks(flexBricks: ISearchBrickItem[]): IBrick[] {
    return flexBricks.map((brick) => {
        return {
            brickNo: brick.brickNo,
            positionNo: 0, // placeholder value
            isFree: brick.isFree,
            items: [
                {
                    positionNo: 0, // placeholder value
                    quantity: brick.quantity,
                    imageFullPath: brick.articleImage,
                    altTagForImage: brick.articleName,
                    brickItemNo: brick.brickItemNo,
                    mainBrickItem: true, // PCS only provides the mainBrickItem
                    isAvailable: true, // placeholder value
                },
            ],
        };
    });
}

export function getPlaceholderCategory(): ICategory {
    return {
        seoSlug: '',
        navigationKey: '',
        categoryName: '',
        hideBreadcrumbAndFilterBar: true,
        hideStickyHeader: true,
        productFinderServicesUpAndRunning: false,
    };
}
